// cry(추모관) FE 분해 Phase 1 (untangle) — router beforeEach 안에 인라인돼 있던 cry 전용 가드 로직.
// 추모관 별도 앱 추출 대비: cry 리다이렉트/헤더 조립을 cry-소유 guard 모듈로 모음.
// ⚠️ 동작보존: 원래 index.js beforeEach 의 제어흐름을 그대로 이식. 특히 cryRedirects 의 next() 는
//    원본과 동일하게 return 없이 호출(fall-through) — 여러 next 중 첫 호출이 이기는 기존 동작 유지.
//    "정리하는 김에" return 추가/조건 변경 금지(스코프 확장 금지·회귀 위험).

import store from '@/store';
import { CRY_TYPE } from '@/common/constants/CryCode';

// beforeEach 초반의 cry 강제 리다이렉트 3종(원본 index.js verbatim):
//  1) 추모관 상세→내 추모관 수정 진입 시 '내가 등록' 경로면 more/memorial 로
//  2) 추모관 등록폼 직접 진입 가드 → cry 메뉴(CREATE)로
//  3) 장례식장 상세→등록폼 이동 시 cry 검색으로
export const cryRedirects = (to, from, next) => {
  if (from.path.includes('/memorial/info/') && to.path.includes('/more/form/memorial/')) {
    if (from.query.from === 'my') {
      // next('/more');
      next(`/more/memorial?memorialType=${from.query.category}`);
    }
  }

  if (
    !from.path.includes('/more/form/memorial/background') &&
    !from.path.includes('/cry/memorial/menu') &&
    !from.path.includes('/memorial/register/form') &&
    !from.path.includes('/cry/preview') &&
    to.path.includes('/memorial/register/form')
  ) {
    next('/cry/memorial/menu?type=CREATE');
  }

  if (from.path.includes('/funeral/info/') && to.path.includes('/funeral/form')) {
    next('/cry/search');
  }
};

// 헤더명에 주입되는 cry 타입 라벨(Inside/Outside/안데르센/온라인 부고장/온라인 장례식장).
// 원본: `CRY_TYPE[store.getters['memorial/getMemorialType']].name`. memorialType 무효 시 throw 하던
// 동작까지 동일 유지(방어 가드 추가 금지 — 기존 계약 보존).
export const cryTypeLabel = () => {
  const memorialType = store.getters['memorial/getMemorialType'];
  return CRY_TYPE[memorialType].name;
};
